
import TitleBox from '@/components/CSS/TitleBox'
import GoodsListPage from '@/components/GoodsListPage'
// import { messagePage, messageRead, messageReadAll } from "@/api/common";
import { messagePath } from '@/enum/localEnum'
import { mapGetters } from 'vuex'
export default {
    components: {
        TitleBox,
        GoodsListPage
    },
    computed: {
        ...mapGetters({
            unreadNumber: 'user/unreadNumber'
        })
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 20,
                total: 100
            },
            messagePageList: []
        }
    },
    methods: {
        gotoMessageDetails(item) {
            // 如果没有读就请求读消息接口
            if (!item.isRead) {
                let p = {
                    action: {
                        id: item.id
                    }
                }
                this.$api.messageRead(p).then(() => {
                    this.$store.dispatch('user/unreadMessageNumber')
                })
            }
            // 标为已读
            item.isRead = true
            switch (item.type) {
                case messagePath.GOODS_ON_STAND:
                case messagePath.GOODS_FORCE_DOWN_STAND:
                case messagePath.GOODS_RESTORE_ON_STAND:
                case messagePath.GOODS_UPDATE_BY_STAFF:
                case messagePath.GOODS_VERIFY_FAIL:
                case messagePath.GOODS_BEAN_SOLD:
                    this.$router.push(`/account/sellerDetails?goodsNo=${item.goodsNo}&gameId=${item.gameId}&goodsCatalogueId=${item.goodsCatalogueId}`)
                    break
                case messagePath.GOODS_BEAN_DEAL:
                case messagePath.GOODS_CANCEL_DEAL:
                    this.$router.push(`/account/buyerDetails?orderNo=${item.orderNo}`)
                    break
                case messagePath.WITHDRAWAL_SUCCESS:
                case messagePath.WITHDRAWAL_FAIL:
                    this.$router.push(`/account/tiXianResultDetails?id=${item.id}`)
                    break
                case messagePath.BLACKLIST_EXAMINATION_PASS:
                case messagePath.BLACKLIST_EXAMINATION_FAIL:
                    break
                default:
                    sessionStorage.setItem('message-detail', JSON.stringify(item))
                    this.$router.push(`/account/messageDetails?id=${item.id}`)
                    break
            }
        },
        setMessageReadAll() {
            const loading = this.$loading({
                lock: true,
                text: '处理中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.$api.messageReadAll().then((res) => {
                loading.close()
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.$store.dispatch('user/unreadMessageNumber')
                this.getMessagePage()
                this.$store.commit('user/SET_UNREAD_NUMBER', null)
                this.$message.success(res.info)
            })
        },
        getMessagePage() {
            let p = {
                action: {},
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            this.$api.messagePage(p).then((res) => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.messagePageList = res.data.records
                this.pageInfo.total = res.data.total
            })
        },
        handleCurrentChange(page) {
            this.pageInfo.page = page
            this.getMessagePage()
        },
        handleSizeChange(pageSize) {
            this.pageInfo.page = 1
            this.pageInfo.pageSize = pageSize
            this.getMessagePage()
        }
    },
    created() {
        this.getMessagePage()
    }
}
